(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-bundle"] && !Shopify.designMode) return;
  try {
    // document.querySelectorAll('.bundle-box__quantity input').forEach((input) => (input.value = 0));
  // document.querySelectorAll('.bundle-box').forEach((box) => box.classList.add('bundle-box--active'));
  // document.querySelectorAll('.bundle-box__quantity input').forEach((input) => console.log(input, input.value));

  // window.addEventListener('load', () => {
  //   document.querySelectorAll('.bundle-box__quantity input').forEach((input) => (input.value = 0));
  //   document.querySelectorAll('.bundle-box').forEach((box) => box.classList.add('bundle-box--active'));
  //   document.querySelectorAll('.bundle-box__quantity input').forEach((input) => console.log(input, input.value));
  // });
  } catch(e) { console.error(e); }
})();

})();
